<div class="order-status-container">
  <img src="/assets/orderstatus.png" />
  <p class="order-status-text">{{ "order completed" | transloco }}</p>
  <p class="order-status-hint">{{ "order completed hint" | transloco }}</p>
  <button class="btn btn-add" routerLink="/Myorders" style="margin-bottom: 10px;">
    {{ "myorders" | transloco }}
  </button>
</div>